import { render } from "./AnnouncementsView.vue?vue&type=template&id=33bd0fae&scoped=true"
import script from "./AnnouncementsView.vue?vue&type=script&lang=js"
export * from "./AnnouncementsView.vue?vue&type=script&lang=js"

import "./AnnouncementsView.vue?vue&type=style&index=0&id=33bd0fae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bd0fae"]])

export default __exports__